<template>
  <div class="teamBuilding" ref="teamBuildingRef" >
    <heads></heads>
    <!--搜索区-->
    <div class="top-banner" ref="contentTopRef"  :style="{backgroundImage:'url(' +'\''+ bannerArray.path +'\''+ ')', backgroundRepeat:'no-repeat', backgroundSize: 'cover'}">
        <div class="title">
            {{ companyName }}
        </div>
        <div class="sub-title">
          {{ title }}
        </div>
    </div>
    <div class="container" ref="containerRef">
      <div class="content">
        <div class="content-top" ref="contentTopRef">
          </div>
        <div class="content-bottom">
          <!--列表区-->
          <div class="building-list" ref="buildingListRef">
            <div>
              <!-- <div
                class="building-list-selections"
                ref="buildingListSelectionsRef"
              >
                <span class="selection-sider">你已选择:</span>
                <div class="selection-item">
                  <ul>
                    <li>
                      <span class="txt">团结队伍</span
                      ><span class="remove">×</span>
                    </li>
                    <li id="sort-result-clear">全部清除</li>
                  </ul>
                </div>
              </div> -->
              <div class="building-list-sort" ref="buildingListSortRef">
                <ul>
                  <li
                    @click="changeSortRule(1)"
                    :class="selectSort == 1 ? 'select' : ''"
                  >
                    默认排序
                  </li>
                  <!-- <li
                    @click="changeSortRule(2)"
                    class="sortTag"
                    :class="selectSort == 2 ? 'select' : ''"
                  >
                    价格<span
                      v-if="selectSort == 2"
                      :class="
                        priceSort == 1
                          ? 'el-icon-caret-top'
                          : (priceSort == 2?'el-icon-caret-bottom':'')
                      "
                    ></span>
                  </li> -->
                </ul>
              </div>
              <div class="building-list-content">
                <div
                  class="building-list-content-item"
                  v-for="item in pageArray"
                  :key="item.id"
                  @click="toDetail(item.id)"
                >
                  <div class="buiiding-list-left">
                    <img :src="getPreUrl + item.image" />
                  </div>
                  <div class="buiiding-list-middle">
                    <div class="title">
                      {{ item.title }}
                    </div>
                    <div class="tags" v-if="item.profitList">
                      <span
                        v-for="(item, index) in item.profitList"
                        :key="index"
                        >{{ item }}</span
                      >
                    </div>
                    <div class="type">
                      <span v-if="item.typeName">{{ item.typeName }}</span
                      ><span class="separator" v-if="item.typeName && item.day"
                        >|</span
                      ><span v-if="item.day"
                        >{{ item.day }}天{{ item.night }}晚</span
                      ><span
                        class="separator"
                        v-if="item.numberMin || item.numberMax"
                        >|</span
                      ><span v-if="item.numberMin || item.numberMax"
                        >{{ item.numberMin }}-{{ item.numberMax }}人</span
                      >
                    </div>
                    <div class="destination">{{ item.destinationName }}</div>
                  </div>
                  <div class="buiiding-list-right">
                    <div class="exponents">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="餐饮指数"
                        placement="left"
                      >
                        <div class="exponent" v-if="item.eatIndex > 3">
                          <i class="fa fa-coffee"></i>
                          <el-rate
                            v-model="item.eatIndex"
                            :colors="['#99A9BF', '#F7BA2A', '#18d3a0']"
                            disabled
                          >
                          </el-rate>
                          <!-- void-icon-class="el-icon-minus" -->
                          <!-- :icon-classes="iconClasses" -->
                        </div>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="团建项目"
                        placement="left"
                      >
                        <div class="exponent" v-if="item.teamIndex > 3">
                          <i class="fa fa-users"></i>
                          <el-rate
                            v-model="item.teamIndex"
                            :colors="['#99A9BF', '#F7BA2A', '#18d3a0']"
                            disabled
                          >
                          </el-rate>
                        </div>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="体力消耗"
                        placement="left"
                      >
                        <div class="exponent" v-if="item.energyIndex > 0">
                          <i class="fa fa-rocket"></i>
                          <el-rate
                            v-model="item.energyIndex"
                            :colors="['#18d3a0', '#18d3a0', '#18d3a0']"
                            disabled
                          >
                          </el-rate>
                        </div>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="景区风光"
                        placement="left"
                      >
                        <div class="exponent" v-if="item.viewIndex > 3">
                          <i class="fa fa-university"></i>
                          <el-rate
                            v-model="item.viewIndex"
                            :colors="['#99A9BF', '#F7BA2A', '#18d3a0']"
                            disabled
                          >
                          </el-rate>
                        </div>
                      </el-tooltip>
                    </div>
                    <div class="price">{{ item.price }}</div>
                    <div class="avg-pirce">{{ item.numberMin }}人均价</div>
                  </div>
                </div>
                <div class="pagination">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="pageNum"
                    :page-size="pageSize"
                    :total="total"
                  ></el-pagination>
                </div>
              </div>
            </div>
            <div></div>
            <!--定制方案区-->
            <div
              class="free-booking"
              ref="freeBookingRef"
              :class="
                freeBookingStyle == 1 ? 'free-booking-1' : 'free-booking-2'
              "
              :style="freeBookingStyle == 2 ? { top: topHeight } : ''"
            >
              <img src="../../../static/images/customizedTipRight.png" @click="goToCustomPage" class="customized-tip"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <homeFoots></homeFoots>
    <quickContact :message="quickContactMessage"></quickContact>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeBottomImage from "@/components/comment/homeBottomImage.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";
import { handlePicPlusPre, fomateDate, handlePic, isPhoneNumber } from "@/util/util.js";
import quickContact from "@/components/comment/quickContact.vue";
import wxShare from "@/common/wx_share.js";
import axios from "axios";
export default {
  name: "teamBuilding",
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      nav: 0,
      freeBookingStyle: 2,
      topHeight: "400px",
      iconClasses: ["el-icon-minus"],
      smsCodeTime: 0,
      // 提交表单
      form: {
        peopleNumber: "",
        avgPrice: "",
        teamBuildingDay: "",
        contact: "",
        mobile: "",
        verificationCode: "",
        wxNumber: "",
        description: "",
      },
      // 团建选择天数
      daySelectId: -1,
      // 团建选择天数类型
      searchDayType: null,
      quickContactMessage: {
        type: 1,
      },
      // 排序规则
      priceSort:-1,
      // 1.过滤条件搜索 2.搜索框搜索
      searchMode:1,
      // 团建天数
      dayList: [
        {
          dayType: 1,
          name: "一天",
          id: 1,
        },
        {
          dayType: 2,
          name: "两天",
          id: 2,
        },
        {
          id: 3,
          dayType: 3,
          name: "三天",
        },
        {
          id: 4,
          dayType: 4,
          name: "四天以上",
        },
      ],
      targetPlace: [
        {
          id: 1,
          name: "本市行政区",
          child: [],
        },
        {
          id: 2,
          name: "省内城市",
          child: [],
        },
        {
          id: 3,
          name: "国内城市",
          child: [],
        },
        {
          id: 4,
          name: "国际长线",
          child: [],
        },
      ],
      // 团建收益扩展列
      profitExpandList: [],
      // 团建收益选中
      profitSelectIndexList: [-1],
      // 团建收益列表
      profitList: [],
      // 团建玩法选中
      playSelectIndex: -1,
      playSelectIndexList: [-1],
      playExpandList: [],
      // 团建玩法二级
      playSecondList: [],
      tbTypeId: -1,
      // 团建玩法
      playList: [],

      // 提交表单
      form: {
        travelNumber: "",
        avgBudget: "",
        teamBuildingDay: "",
        contact: "",
        mobile: "",
        verificationCode: "",
        wxNumber: "",
        description: "",
      },
      // --
      activeIndex: 0,
      title: "",
      subjectId: 54,
      pageArray: [],
      loading: false,
      searchVal: "",
      selectList: {},
      priceSort: "",
      selectSort: 1,

      // 团建目的地相关字段
      scenicSpotsList: [],
      // 省内城市
      surroundCityList: [],
      // 国际长线
      foreignCityList: [],
      // 国内城市
      domesticCityList: [],
      
      regionList: [],

      targetPlaceNum: -1,
      placeContentArray: [],
      placeSelectIndex: {
        typeNumber: -1,
        id: -1,
      },
      searchCityId: null,
      searchScenicSpotsId: null,
      searchRegionId: null,
      destinationId: null,
      placeSecondList: [],
      workBenchId:null,
      companyName:null,
      title:null,
      image:null,
      bannerArray:{path:""},
    };
  },
  components: {
    heads,
    homeFoots,
    banners,
    quickContact,
    homeBottomImage
  },
  computed: {
    getPreUrl() {
      return this.$store.state.picPreUrl;
    },
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity;
    },
    getRequirementType() {
      return this.$store.state.requirementTypeData;
    },
  },
  watch: {},
  methods: {
    isPhoneNumber,
    fomateDate,
    handlePicPlusPre,
    handlePic,
     // 获取广告
     getBanner(){
      const params = {
        positionId:24,
        cityId:this.getLocationSiteCityId
      }
      axios
        .get(`/api/adm/list`, {
          params
        })
        .then((res) => {
          // console.log(res)
          if(res.data &&res.data.code == 200){
            if (res.data.adList) {
              this.bannerArray = res.data.adList;
              if (this.bannerArray && this.bannerArray.length>0) {
                this.bannerArray.forEach((banner) => {
                  if (banner.path) {
                    banner.path = this.handlePicPlusPre(banner.path);
                  } else {
                    banner.path = "ak.jpg";
                  }
                  banner.path = banner.path[0];
                });
                console.log(this.bannerArray)
                this.bannerArray = this.bannerArray[0];
              }
              console.log("this.bannerArray",this.bannerArray)
            }
          }
        })
    },
    // 去定制页面
    goToCustomPage(){
      window.open("/#/custom");
    },
    toDetail(id) {
      window.open("/#/teamBuildingDetail?id="+id)
    },
    // -- 分页方法
    handleCurrentChange(val) {
      this.loading = true;
      this.dispatchQuery();
    },
    handleSizeChange(val) {
      console.log("当前页:" + val);
    },
    // 查询调度方法
    async dispatchQuery(){
      await this.getTbPage();
    },
    // -- 分页方法
    getTbPage() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        workbenchId: this.workBenchId,
      };
      axios
        .get(`/api/tb/customTbList`, {
          params,
        })
        .then((res) => {
          if (res.data.code == 200) {
            let data = res.data.data;
            this.companyName = data.name;
            this.title = data.title;
            this.image = data.image;
            this.total = data.page.total;
            this.pageArray = data.page.rows;
            this.pageArray.forEach((tb) => {
              if (tb.profitNames) {
                let profitList = tb.profitNames.split(" ");
                tb.profitList = profitList;
              }
              if (tb.typeNames) {
                let typeNameList = tb.typeNames.split(" ");
                tb.typeName = typeNameList[0];
              }
              if (tb.image) {
                let imageList = handlePic(tb.image);
                if (imageList != null && imageList.length > 0) {
                  tb.image = imageList[0];
                }
              }
            });
            this.loading = false;
          }
        });
        this.wxShareForTeamBuilding();
    },

    toSearch() {
      this.loading = true;
      this.searchMode = 2;
      this.getSearchTbPage();
    },

    // 改变分页排序规则
    changeSortRule(val) {
      if (this.selectSort == val && val == 1) {
        this.priceSort = -1;
        return;
      }
      this.selectSort = val;
      if (val == 2) {
        if (this.priceSort == 2) {
          this.priceSort = 1;
        } else {
          this.priceSort = 2;
        }
      } else {
        this.priceSort = -1;
      }
      // 分页条件重置
      this.dispatchQuery();
      // 搜索
    },
    // 判断数组是否包含
    selectContains(array, index) {
      // debugger
      console.log("---|---");
      return array.indexOf(index) > -1 ? true : false;
    },
    // 正式时要分开
    // 天数单选
    daySimpleSelect(item) {
      if (item) {
        this.searchDayType = item.dayType;
        this.daySelectId = item.id;
      } else {
        this.searchDayType = null;
        this.daySelectId = -1;
      }
      // 加入搜索
      this.searchMode = 1;
      this.getTbPage();
    },

    // 搜索多选
    earningsMoreSelect(array, index) {
      // 如果为不限，清除其他
      if (index == -1) {
        array = [-1];
      } else {
        if (this.selectContains(array, index)) {
          let position = array.indexOf(index);
          array.splice(position, 1);
        } else {
          array.push(index);
        }
      }
      // 将其存入 selectList中

      // 请求
    },
    // 玩法搜索单选
    playSelect(item) {
      // 选的一级和之前不一样清除二级
      if (
        item.playTypeId == this.playSelectIndex ||
        item == this.playSelectIndex
      ) {
        return;
      }
      this.playSelectIndexList = [-1];
      // 如果为不限，清除二级
      if (item == -1) {
        this.playSelectIndex = item;
        this.playSecondList = [];
      } else {
        console.log(item);
        this.playSelectIndex = item.playTypeId;
        this.playSecondList = item.playList;
      }
      this.searchMode = 1;
      this.getTbPage();
      // let selectParam = new Object();
      // selectParam.type = type;
      // selectParam.name =this.playList[index].name;
      // 请求
    },
    // 处理查询地点（城市，景区，行政区）
    placeChange() {
      let { typeNumber, id } = this.placeSelectIndex;
      // if (typeNumber == 0) {
      //   this.searchRegionId = id;
      // } else if (typeNumber == 1) {
      //   this.searchCityId = id;
      // } else if (typeNumber == 2) {
      //   this.searchScenicSpotsId = id;
      // } else {
      // }
      this.placeClear();
      if (typeNumber == 0) {
        this.searchRegionId = id;
      } else if (typeNumber == 1 || typeNumber == 2 ||  typeNumber == 3) {
        this.searchCityId = id;
      } else {

      }
    },
    // 清理查询地点（城市，景区，行政区）
    placeClear() {
      console.log("placeClear")
      this.searchCityId = null;
      this.searchScenicSpotsId = null;
      this.searchRegionId = null;
    },
    // 判断地点（城市，景区，行政区）是否选中
    placeSelectContain(typeNumberParam, idParam) {
      let { typeNumber, id } = this.placeSelectIndex;
      console.log("-placeSelectContain-");
      console.log(typeNumberParam, idParam);
      console.log(typeNumber, id);
      if (typeNumberParam == typeNumber && idParam == id) {
        return true;
      } else {
        return false;
      }
    },
    // 选择地点
    placeSimpleSelect(typeNumber, id) {
      console.log("-placeSimpleSelect-");
      if (!this.placeSelectContain(typeNumber, id)) {
        this.placeSelectIndex = {
          typeNumber: typeNumber,
          id: id,
        };
      }
      // 处理搜索参数
      this.placeChange();
      // 搜索
      this.searchMode = 1;
      this.getTbPage();
    },
    // 选择地点(无跳转)
    placeSimpleSelect2(typeNumber, id) {
      console.log("-placeSimpleSelect-");
      if (!this.placeSelectContain(typeNumber, id)) {
        this.placeSelectIndex = {
          typeNumber: typeNumber,
          id: id,
        };
      }
      // 处理搜索参数
      this.placeChange();
      // 搜索
      this.searchMode = 1;
    },
    // 玩法搜索多选
    playMoreSelect(item) {

      // 如果为不限，清除其他
      if (item == -1) {
        this.playSelectIndexList = [-1];
        // this.playSecondList = [];
      } else {
        console.log(this.playSelectIndexList);
        if (this.selectContains(this.playSelectIndexList, item.playId)) {
          let position = this.playSelectIndexList.indexOf(item.playId);
          this.playSelectIndexList.splice(position, 1);
          // 当全部都点掉时，补充不限进列表
          if (this.playSelectIndexList.length < 1) {
            this.playSelectIndexList = [-1];
          }
        } else {
          if (this.selectContains(this.playSelectIndexList, -1)) {
            this.playSelectIndexList.splice(0, 1);
          }
          this.playSelectIndexList.push(item.playId);
        }
      }
      // 开始请求
      this.searchMode = 1;
      this.getTbPage();
      return;
    },

    // 收益多选
    profitMoreSelect(item) {
      // 如果为不限，清除其他
      if (!item) {
        this.profitSelectIndexList = [-1];
        // 搜索
        this.searchMode = 1;
        this.getTbPage();
        return;
      }
      console.log(this.profitSelectIndexList);
      if (this.selectContains(this.profitSelectIndexList, item.profitId)) {
        let position = this.profitSelectIndexList.indexOf(item.profitId);
        this.profitSelectIndexList.splice(position, 1);
        // 当全部都点掉时，补充不限进列表
        if (this.profitSelectIndexList.length < 1) {
          this.profitSelectIndexList = [-1];
        }
      } else {
        if (this.selectContains(this.profitSelectIndexList, -1)) {
          this.profitSelectIndexList.splice(0, 1);
        }
        this.profitSelectIndexList.push(item.profitId);
      }
      // 开始请求
      this.searchMode = 1;
      this.getTbPage();
      return;
    },

    // 收益多选(无跳转)
    profitMoreSelect2(item) {
      console.log("profitMoreSelect2")
      // 如果为不限，清除其他
      if (!item) {
        this.profitSelectIndexList = [-1];
        // 搜索
        this.searchMode = 1;
        return;
      }
      console.log(this.profitSelectIndexList);
      if (this.selectContains(this.profitSelectIndexList, item.profitId)) {
        let position = this.profitSelectIndexList.indexOf(item.profitId);
        this.profitSelectIndexList.splice(position, 1);
        // 当全部都点掉时，补充不限进列表
        if (this.profitSelectIndexList.length < 1) {
          this.profitSelectIndexList = [-1];
        }
      } else {
        if (this.selectContains(this.profitSelectIndexList, -1)) {
          this.profitSelectIndexList.splice(0, 1);
        }
        this.profitSelectIndexList.push(item.profitId);
      }
      console.log("this.profitSelectIndexList",this.profitSelectIndexList)
      // 开始请求
      this.searchMode = 1;
      return;
    },

    // 获取团建查询条件
    getTbCondition() {
      axios.get("/api/tb/tbCondition").then((res) => {
        if (res.data && res.data.code == 200) {
          this.playList = res.data.play;
          if (
            this.playSelectIndex != -1 &&
            this.playList &&
            this.playSelectIndexList &&
            this.playSelectIndexList.length > 0 &&
            this.playSelectIndexList[0] != -1
          ) {
            this.playList.forEach((playItem) => {
              if (playItem.playTypeId == this.playSelectIndex) {
                this.playSecondList = playItem.playList;
              }
            });
          }
          this.profitList = res.data.profit;
        }
      });
    },

    // 选择目的地
    selectTargetPlace(index) {
      if (this.targetPlaceNum != index && index == -1) {
        this.targetPlaceNum = index;
        this.placeContentArray = [];
        this.placeClear();
        this.searchMode = 1;
        this.getTbPage();
        // 重新搜索
      } else {
        this.targetPlaceNum = index;
        this.placeContentArray = this.targetPlace[index].child;
      }
    },

    // 查询行政区
    getRegionList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        cityId: cityId,
      };
      axios
        .get(`/api/city/cityRegionList`, {
          params,
        })
        .then((res) => {
          if (res.status == 200 && res.data.code == 200) {
            this.regionList = res.data.cityRegionList;
            if (this.regionList) {
              this.regionList.forEach((region) => {
                region.id = region.regionId;
                region.name = region.regionName;
              });
            }
            console.log("--regionList---");
            if (this.targetPlaceNum == 0) {
              this.placeContentArray = this.regionList;
            }
            this.targetPlace[0].child = this.regionList;
            console.log(this.targetPlace[0].child);
          }
        });
    },
    // 查询景区
    getScenicSpotsList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        cityId: cityId,
      };
      axios
        .get(`/api/city/scenicSpotslist`, {
          params,
        })
        .then((res) => {
          if (res.status == 200 && res.data.code == 200) {
            this.scenicSpotsList = res.data.scenicSpotslist;
            if (this.targetPlaceNum == 2) {
              this.placeContentArray = this.scenicSpotsList;
            }
            this.targetPlace[2].child = this.scenicSpotsList;
          }
        });
    },
    // 查询省内城市
    getSurroundCityList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        siteCityId: cityId,
      };
      axios
        .get(`/api/city/surroundCityList`, {
          params,
        })
        .then((res) => {
          if (res.status == 200 && res.data.code == 200) {
            this.surroundCityList = res.data.surroundCityList;
            if (this.surroundCityList) {
              this.surroundCityList.forEach((surroundCity) => {
                surroundCity.id = surroundCity.cityId;
                surroundCity.name = surroundCity.cityName;
              });
            }
            if (this.targetPlaceNum == 1) {
              this.placeContentArray = this.surroundCityList;
            }
            this.targetPlace[1].child = this.surroundCityList;
          }
        });
    },
    // 查询国内城市
    getDomesticCityList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        siteCityId: cityId,
      };
      axios
        .get(`/api/city/domesticCityList`, {
          params,
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.domesticCityList = res.data.domesticCityList;
            if (this.domesticCityList) {
              this.domesticCityList.forEach((domesticCity) => {
                domesticCity.id = domesticCity.cityId;
                domesticCity.name = domesticCity.cityName;
              });
            }
            if (this.targetPlaceNum == 2) {
              this.placeContentArray = this.domesticCityList;
            }
            this.targetPlace[2].child = this.domesticCityList;
          }
        });
    },
     // 查询国际长线
    getForeignCityList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        siteCityId: cityId,
      };
      axios
        .get(`/api/city/foreignCityList`, {
          params,
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.foreignCityList = res.data.foreignCityList;
            if (this.foreignCityList) {
              this.foreignCityList.forEach((foreignCity) => {
                foreignCity.id = foreignCity.cityId;
                foreignCity.name = foreignCity.cityName;
              });
            }
            if (this.targetPlaceNum == 3) {
              this.placeContentArray = this.foreignCityList;
            }
            this.targetPlace[3].child = this.foreignCityList;
          }
        });
    },

  // 微信分享接口调用
  wxShareForTeamBuilding(){
    // 微信分享
    if (wxShare.is_wx()) {
      let url = window.location.href
      wxShare.wxReWriteShare(
        `${this.companyName?this.companyName:this.$store.state.defaultTitle}`,
        `${this.title?this.title:this.$store.state.defaultDesc}`,
        `${url}`,
        `${this.image?this.image:this.$store.state.defaultPic}`
      );
    }
  },
    // 计算免费定制的显示
    handleScrollx() {
      let contentTopBottom =
        this.$refs.contentTopRef.getBoundingClientRect().bottom;
      let freeBookingBottom =
        this.$refs.freeBookingRef.getBoundingClientRect().bottom;
      let buildingListBottom =
        this.$refs.buildingListRef.getBoundingClientRect().bottom;
      let freeBookingRefHeight = this.$refs.freeBookingRef.offsetHeight;
      // let buildingListSelectionsRefHeight =
      //   this.$refs.buildingListSelectionsRef.offsetHeight;
      let buildingListSortHeight = this.$refs.buildingListSortRef.offsetHeight;
      let condition1 =
        buildingListBottom -
        freeBookingRefHeight -
        // buildingListSelectionsRefHeight -
        buildingListSortHeight -
        60;
      if (condition1 >= 0 && contentTopBottom <= 0) {
        this.freeBookingStyle = 1;
        return;
      } else {
        this.freeBookingStyle = 2;
      }

      // 默认计算触顶位置
      let contentTopRefHeight = this.$refs.contentTopRef.offsetHeight;
      this.topHeight =
        contentTopRefHeight +
        // buildingListSelectionsRefHeight +
        buildingListSortHeight +
        60 +
        "px";
      // 计算触底位置
      console.log(buildingListBottom);
      console.log(freeBookingRefHeight);
      // 数据大于3条才会触发
      if (buildingListBottom - freeBookingRefHeight - 140 < 0) {
        let containerRefHeight = this.$refs.containerRef.offsetHeight;
        this.topHeight = containerRefHeight - freeBookingRefHeight - 60 + "px";
      }
    },
  },

  mounted() {
    this.handleScrollx();
    window.addEventListener("scroll", this.handleScrollx, true);
    this.wxShareForTeamBuilding();
  },


  created() {
    // 是否是文字搜索框的方式搜索
    if (this.$route.query) {
      if (this.$route.query.pageNum) {
        this.pageNum = this.$route.query.pageNum
      }
      if (this.$route.query.workBenchId) {
        this.workBenchId = this.$route.query.workBenchId
      }
    }
    this.loading = true;
    this.getTbPage();
    this.getBanner();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScrollx, true);
  },
};
</script>

<style scoped>
.teamBuilding {
  width: 100%;
  height: 100%;

  /* text-align: left; */
}
.container {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 1060px;
}
.content {
  width: 100%;
  /* display: flex;
    flex-wrap: wrap;
    justify-content: space-between; */
}
/* 搜索 */
.top-banner {
  background-color: #f8f8f8;
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.top-banner {
  background-color: #f8f8f8;
  width: 100%;
  height: 400px;
}
.top-banner .title{
  font-weight: bold;
  color: #fff;
  font-size: 40px;
  margin: 0 20px;
}
.top-banner .sub-title{
  /* font-weight: bold; */
  color: #fff;
  font-size: 35px;  
  margin: 0 20px;
}
.search-wrapper {
  width: 100%;
  /* position: absolute; */
  display: flex;
  justify-content: left;
  bottom: 0px;
  z-index: 9;
  box-sizing: border-box;
  color: #fff;
  padding: 20px 20px;
  font-size: 14px;
  padding: 20px 20px;

  /* background: rgba(0, 0, 0, 0.38); */
}
.search-input-wrapper {
  display: flex;
  border-radius: 4px;
  padding: 5px;
  margin-top: 8px;
  position: relative;
  width: 800px;
}
.search-input {
  flex: 1;
  padding: 0 10px;
  /* border: 0; */
  border-radius: 4px;
  line-height: 45px;
  border: 1px solid #cccccc;
}
.search-btn {
  background: #359ff8;
  padding: 12px 25px;
  border-radius: 0 4px 4px 0;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}
.search-btn:hover {
  /* background: #98D9C1; */
}
.search-select-item {
  /* position: relative; */
  padding: 6px 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  /* align-content: center;
    justify-items: center;
    align-items: center; */
}

.search-select-item .select-sider {
  display: block;
  width: 90px;
  padding-left: 30px;
  /* position: relative; */
  left: 23px;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  /* width: fit-content; */
  color: #545658;
  text-align: left;
}
.search-select-item .select-tabs {
  /* margin-left: 50px;
    margin-right: 70px;
    padding-right: 40px; */
  overflow: hidden;
  width: 860px;
  /* position: relative; */
}
.search-select-item .close-open {
  /* height: 30px;
    line-height: 30px;
    text-align: right;
    display: inline-block;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0; */
  font-weight: 700;
  font-size: 12px;
  padding-top: 5px;
  color: #18d3a0;
}
.search-select-item .select-tabs ul {
  list-style: none;
}
.search-select-item .select-tabs ul li {
  cursor: pointer;
  margin: 0 6px;
  padding: 0 12px 6px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  border: 1px solid transparent;
  font-size: 14px;
  color: #515255;
  border-radius: 15px;
}
.search-select-item .select-tabs ul .select {
  cursor: pointer;
  margin: 0 6px;
  padding: 0 12px;
  height: 30px;
  display: inline-block;
  font-weight: 700;
  color: #fff;
  background-color: #359ff8;
  line-height: 30px;
  border: 1px solid transparent;
  font-size: 14px;
  border-radius: 15px;
}
.search-item .select-tabs {
  cursor: pointer;
  margin: 0 6px;
  padding: 0 12px;
  height: 30px;
  display: inline-block;
  font-weight: 700;
  color: #fff;
  background-color: #359ff8;
  line-height: 30px;
  border: 1px solid transparent;
  font-size: 14px;
  color: #515255;
  border-radius: 15px;
}
.select-items .select-tabs ul .select {
  color: #088dfa !important;
  font-weight: 100 !important;
  background-color: #c2e2fd;
}

/* 列表 */
.building-list {
  width: 746px;
  background-color: #fff;
}
.building-list .building-list-selections {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  padding-top: 10px;
  cursor: pointer;
  margin-bottom: 20px;
}
.building-list .building-list-selections .selection-sider {
  width: 100px;
  padding-left: 20px;
  display: block;
  height: 18px;
  line-height: 18px;
  font-size: 14px;
  color: #222;
  text-align: left;
}
.building-list .building-list-selections .selection-item {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  /* justify-content: flex-start;
  align-content: flex-start;   */
}
.building-list .building-list-selections .selection-item ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style: none;
}
.building-list .building-list-selections .selection-item ul li {
  cursor: pointer;
  margin: 0 6px 6px 0;
  height: 18px;
  line-height: 16px;
  background: #fff;
  display: inline-block;
  font-size: 12px;
  color: #262522;
  border: 1px solid #515255;
  display: flex;
  flex-direction: row;
}
.building-list .building-list-selections .selection-item ul li .txt {
  padding: 2px 6px;
  height: 18px;
  line-height: 14px;
  display: inline-block;
}
.building-list .building-list-selections .selection-item ul li .remove {
  margin-right: -1px;
  padding: 1px 0 0;
  font-size: 10px;
  background: #515255;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  width: 18px;
}
#sort-result-clear {
  color: #359ff8;
  cursor: pointer;
  margin: 0 6px 6px 0;
  height: 18px;
  line-height: 16px;
  background: #fff;
  display: inline-block;
  font-size: 12px;
  border: none;
}
.building-list .building-list-sort {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  padding-top: 10px;
  cursor: pointer;
  border-bottom: 1px solid #cccccc;
  margin-bottom: 20px;
}
.building-list .building-list-sort ul {
  list-style: none;
}
.building-list .building-list-sort ul li {
  height: 30px;
  line-height: 30px;
  display: inline-block;
  font-size: 14px;
  color: #515255;
  text-align: left;
  width: 100px;
  border-radius: 4px 4px 0 0;
  text-align: center;
  position: relative;
  cursor: pointer;
}
.building-list .building-list-sort ul .select {
  background: #359ff8;
  font-weight: 700;
  font-size: 14px;
  color: #fff;
}
.building-list-content {
  width: 100%;
  min-height: 600px;
}
.building-list-content .building-list-content-item {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: flex-start;
  padding: 10px 0px;
  cursor: pointer;
}
.building-list-content .building-list-content-item:hover .title {
  color: #359ff8;
}
.building-list-content-item .buiiding-list-left {
  flex: 3;
}
.building-list-content-item .buiiding-list-left img {
  width: 200px;
  height: 163px;
  display: block;
  background: #efefef;
  border-radius: 3px;
  overflow: hidden;
  /* height: 100%; */
  float: left;
  object-fit: cover;
}
.building-list-content-item .buiiding-list-middle {
  display: flex;
  flex-direction: column;
  flex: 5;
  flex-wrap: nowrap;
  align-content: flex-start;
  padding: 10px 40px 10px 0px;
}
.building-list-content-item .buiiding-list-middle div {
  margin-bottom: 10px;
}
.building-list-content-item .buiiding-list-middle .title {
  font-weight: 700;
  font-size: 18px;
  color: #222;
  overflow: hidden;
  /* padding: 0 140px 10px 20px; */
  max-height: 80px;
}

.building-list-content-item .buiiding-list-middle .tags {
  overflow: hidden;
}
.building-list-content-item .buiiding-list-middle .tags span {
  padding: 0 6px;
  background: #f5f5f5;
  border-radius: 2px;
  height: 28px;
  line-height: 28px;
  display: inline-block;
  font-size: 12px;
  color: #5a5a5a;
  text-align: center;
  margin-right: 5.8px;
}

.building-list-content-item .buiiding-list-middle .type span {
  color: #5a5a5a;
  font-size: 14px;
  overflow: hidden;
}
.building-list-content-item .buiiding-list-middle .type .separator {
  padding: 0px 5px;
}
.building-list-content-item .buiiding-list-middle .destination {
  color: #5a5a5a;
  font-size: 14px;
  overflow: hidden;
}
.building-list-content-item .buiiding-list-right {
  flex: 2;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: flex-start;
}
.building-list-content-item .buiiding-list-right div {
  /* margin-bottom: 10px; */
}
.building-list-content-item .buiiding-list-right .exponents {
  margin-bottom: 10px;
}
.building-list-content-item .buiiding-list-right .exponent {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.building-list-content-item .buiiding-list-right .exponent .el-icon-dish {
  width: 20px;
  text-align: left;
  color: #18d3a0;
}
.building-list-content-item .buiiding-list-right .exponent i {
  width: 20px;
  text-align: left;
  color: #18d3a0;
}
.building-list-content-item .buiiding-list-right .exponent .el-rate__icon {
  font-size: 12px;
}
.buiiding-list-right .icon {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: flex-start;
}
.buiiding-list-right .price {
  display: inline;
  font-weight: 700;
  font-size: 24px;
  color: #f9541c;
}
.buiiding-list-right .price::after {
  content: " 元起/人";
  font-size: 12px;
  color: #666;
}
.buiiding-list-right .avg-price {
  font-size: 12px;
  color: #666;
}
/* 免费定制 */
.free-booking {
  left: auto;
  margin-top: 0px;
  width: 300px;
  cursor: pointer;
  /* bottom: 20px; */
  z-index: 0;
  margin-left: 756px;
  background: #fff;
  border: 2px solid #359ff8;
  border-radius: 3px;   
  display: flex;
  flex-direction: column;
  position: relative;
}
.free-booking-1 {
  position: fixed;
  top: 80px;
}
.free-booking-2 {
  position: absolute;
  /* top: 750px; */
  /* position: relative;
    top: -2100px; */
}
.free-booking .free-booking-header {
  text-align: center;
}
.free-booking .free-booking-header .free-booking-dot {
  display: inline-block;
  background: #359ff8;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  vertical-align: middle;
  margin: 0 10px;
}
.free-booking .free-booking-header .free-booking-title {
  display: inline-block;
  font-weight: 700;
  font-size: 20px;
  color: #222;
  letter-spacing: 1px;
  height: 80px;
  line-height: 80px;
  vertical-align: middle;
}
.free-booking-item {
  position: relative;
  padding: 9px 25px 9px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
}
.free-booking-item .txt {
  display: inline;
  flex: 47;
  text-align: right;
  padding: 10px 5px 10px 0px;
}
.free-booking-item >>> div {
  flex: 100;
}

.sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border: none;
  background: #f8f8f8;
  border-radius: 6px;
}
/* el-select 样式 */
.free-booking-item >>> .el-input__inner,
.free-booking-item >>> .el-input__suffix {
  background-color: #f8f8f8;
}
.free-booking .free-booking-item2 >>> .el-input__inner {
  width: 170px !important;
}
.free-booking-item >>> .el-input__inner {
  border: none;
  width: 170px !important;
  background-color: #f8f8f8;
}
.free-booking-item .sendCode >>> .el-input__inner {
  border: none;
  border-color: transparent;
  background: fixed;
  width: 105px !important;
  margin-top: 0px !important;
}
.sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161, 0.2);
  cursor: pointer;
  width: 60px;
  padding-right: 5px;
}
.sendCode .active-txt2 {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161);
  cursor: pointer;
  width: 60px;
  padding-right: 5px;
}
.request::before {
  content: "*";
  color: red;
  position: relative;
}
.el-select-dropdown__list .selected {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  color: #606266 !important;
}
.free-booking-item .el-select-dropdown__item:hover {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  background: #f8f8f8;
}

.free-booking-item .txt {
  padding-top: 10px;
  display: block;
  width: 100%;
}
.txt1 {
  width: auto !important;
  padding-bottom: 5px;
}

.free-booking-item-order .txt {
  padding-right: 5px;
  display: block;
  width: 100%;
}
.tool-button-primary button {
  color: #fff;
  font-weight: 700;
}
.tool-button button {
  outline: none;
  background: none;
  border: none;
  width: 250px;
  height: 100%;
  cursor: pointer;
}
.free-booking-itemimg {
  margin-top: 30px;
  width: 600px;
}
.element-row {
  flex-flow: row wrap;
}

.tool-button {
  width: 100%;
  position: relative;
  font-weight: 700;
  font-size: 16px;
  color: #222;
  background: #222;
  letter-spacing: 1.6px;
  text-align: center;
  border-radius: 2px;
  height: 44px;
}
.buiiding-list-right .fa:before {
    font-size: 12px!important;
}
.buiiding-list-right >>>.el-rate__icon{
  font-size: 14px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/teamBuildingView/tbWorkBenchList.vue